import React from "react";
import Svg, { Path } from "react-native-svg";

function Landing({ height = "133.69", width = "161.04", ...props }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 162 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M80.5207 133.689C124.991 133.689 161.041 131.609 161.041 129.044C161.041 126.478 124.991 124.398 80.5207 124.398C36.0503 124.398 0 126.478 0 129.044C0 131.609 36.0503 133.689 80.5207 133.689Z"
        fill="#E6E6E6"
      />
      <Path
        d="M126.612 44.9713C126.612 44.9713 124.211 44.1139 122.668 47.5433C121.125 50.9726 118.724 54.7449 118.724 54.7449L120.096 55.0879C120.096 55.0879 120.439 52.6873 121.296 52.3444L120.953 55.4308C120.953 55.4308 131.241 59.0316 135.871 55.0879L135.699 53.8876C135.699 53.8876 136.385 54.0591 136.385 55.0879L136.9 54.5735C136.9 54.5735 136.385 53.5446 134.842 52.1729C133.829 51.2726 133.481 49.5596 133.362 48.4887C133.272 47.5945 132.914 46.7482 132.335 46.0608C131.31 44.8723 129.441 43.609 126.612 44.9713Z"
        fill="#2F2E41"
      />
      <Path
        d="M112.513 74.3885L114.758 77.2456L116.187 75.613L114.962 73.5723L112.513 74.3885Z"
        fill="#FBBEBE"
      />
      <Path
        d="M111.697 118.266L110.881 122.551L112.922 123.571L114.35 122.551V118.266H111.697Z"
        fill="#FBBEBE"
      />
      <Path
        d="M125.982 118.266L126.798 122.551L124.758 123.571L123.329 122.551V118.266H125.982Z"
        fill="#FBBEBE"
      />
      <Path
        d="M117.615 79.6953L114.758 100.102L110.677 118.673L115.575 119.285L119.452 101.939L124.35 87.2461L123.737 104.796L122.717 119.285H126.39L129.043 99.6945L131.977 85.1289L131.9 79.6953H117.615Z"
        fill="#2F2E41"
      />
      <Path
        d="M112.309 122.141C112.309 122.141 111.289 120.917 110.677 121.529C110.064 122.141 108.636 124.59 108.636 124.59C108.636 124.59 105.371 126.427 108.024 126.835C110.677 127.243 111.493 126.835 111.493 126.631C111.493 126.427 111.901 125.814 111.901 125.814L112.921 126.018L114.35 125.61C114.35 125.61 114.962 121.85 114.35 121.996C113.738 122.141 112.513 122.753 112.309 122.141Z"
        fill="#2F2E41"
      />
      <Path
        d="M125.37 122.141C125.37 122.141 126.39 120.917 127.003 121.529C127.615 122.141 129.043 124.59 129.043 124.59C129.043 124.59 132.308 126.427 129.655 126.835C127.003 127.243 126.186 126.835 126.186 126.631C126.186 126.427 125.778 125.814 125.778 125.814L124.758 126.018L123.329 125.61C123.329 125.61 122.717 121.85 123.329 121.996C123.941 122.141 125.166 122.753 125.37 122.141Z"
        fill="#2F2E41"
      />
      <Path
        d="M127.308 55.5125C129.563 55.5125 131.39 53.6851 131.39 51.431C131.39 49.1769 129.563 47.3496 127.308 47.3496C125.054 47.3496 123.227 49.1769 123.227 51.431C123.227 53.6851 125.054 55.5125 127.308 55.5125Z"
        fill="#FBBEBE"
      />
      <Path
        d="M130.064 53.9824C130.064 53.9824 129.655 57.4516 129.859 58.2679C130.064 59.0842 130.472 60.3086 130.472 60.3086L123.941 59.0842C123.941 59.0842 125.778 55.2069 125.37 54.5946C124.962 53.9824 130.064 53.9824 130.064 53.9824Z"
        fill="#FBBEBE"
      />
      <Path
        d="M130.676 58.8797L123.941 57.4512L120.064 81.1235C121.812 80.6462 123.664 80.7174 125.37 81.3275C128.227 82.3479 132.104 81.3275 132.104 81.3275L131.288 59.0838L130.676 58.8797Z"
        fill="#E40046"
      />
      <Path
        d="M125.313 55.5762L122.921 56.8388L119.86 57.451L116.595 65.2057L117.003 70.7157C117.003 70.7157 113.534 77.0419 113.125 80.5111C113.125 80.5111 113.534 85.8169 120.268 85.6129L124.758 73.1645C124.758 73.1645 126.594 63.7773 124.758 61.1243C124.758 61.1243 126.072 56.1502 125.313 55.5762Z"
        fill="#2F2E41"
      />
      <Path
        d="M121.084 57.4506L120.423 57.3379L119.86 57.4506C119.86 57.4506 118.431 57.6547 116.799 59.0832C115.166 60.5117 109.656 65.0013 109.248 66.2257C108.84 67.4501 109.044 69.4908 109.656 70.7153C110.268 71.9397 111.493 73.5723 111.493 73.5723L112.105 75.0007L115.574 73.9804C115.574 73.9804 113.329 69.6949 113.533 67.8583L117.615 64.5931L121.084 57.4506Z"
        fill="#2F2E41"
      />
      <Path
        d="M129.837 56.498L132.92 60.3073L134.553 62.348L132.512 69.2864L131.492 75.2045C131.492 75.2045 133.941 84.5918 131.9 87.4488C131.9 87.4488 130.676 88.8773 130.267 87.2447C129.859 85.6122 129.859 77.8575 129.859 77.8575C129.859 77.8575 128.227 67.6539 129.043 65.001C129.859 62.348 128.999 56.9743 129.837 56.498Z"
        fill="#2F2E41"
      />
      <Path
        d="M132.716 86.0205V88.0612C132.716 88.0612 132.308 94.7955 134.349 93.9793C136.39 93.163 134.961 88.0612 134.961 88.0612L134.757 85.8164L132.716 86.0205Z"
        fill="#FBBEBE"
      />
      <Path
        d="M122.759 51.6499C124.311 50.5266 125.567 49.2328 126.399 47.6937C126.399 47.6937 129.247 50.8586 130.988 51.0169C132.728 51.1751 131.146 47.219 131.146 47.219L127.981 46.4277L124.974 46.7442L122.601 48.3267L122.759 51.6499Z"
        fill="#2F2E41"
      />
      <Path
        d="M132.92 61.7363L134.553 62.3486L134.757 64.3893L135.573 76.8376L135.165 86.2249L132.104 86.4291L131.084 76.0214L130.676 64.5935L132.92 61.7363Z"
        fill="#2F2E41"
      />
      <Path
        d="M83.2305 30.6657H82.5214V11.2419C82.5214 9.76563 82.2307 8.30377 81.6657 6.93983C81.1007 5.57589 80.2727 4.33659 79.2287 3.29268C78.1848 2.24877 76.9455 1.42069 75.5816 0.855733C74.2177 0.290774 72.7558 -4.32112e-06 71.2795 0H30.1277C28.6514 -4.32112e-06 27.1895 0.290774 25.8256 0.855733C24.4617 1.42069 23.2223 2.24877 22.1784 3.29268C21.1345 4.33659 20.3064 5.57589 19.7415 6.93983C19.1765 8.30377 18.8857 9.76563 18.8857 11.2419V117.802C18.8857 119.278 19.1765 120.74 19.7415 122.104C20.3064 123.468 21.1345 124.707 22.1784 125.751C23.2223 126.795 24.4617 127.623 25.8256 128.188C27.1895 128.753 28.6514 129.044 30.1277 129.044H71.2795C72.7558 129.044 74.2177 128.753 75.5816 128.188C76.9455 127.623 78.1848 126.795 79.2287 125.751C80.2727 124.707 81.1007 123.468 81.6657 122.104C82.2307 120.74 82.5214 119.278 82.5214 117.802V44.4918H83.2305V30.6657Z"
        fill="#004170"
      />
      <Path
        d="M80.1285 11.3196V117.723C80.1284 119.95 79.2439 122.085 77.6694 123.66C76.0949 125.234 73.9594 126.119 71.7327 126.119H30.3835C28.1569 126.119 26.0214 125.234 24.4469 123.66C22.8724 122.085 21.9878 119.95 21.9878 117.723V11.3196C21.9878 9.09289 22.8724 6.95743 24.4469 5.38293C26.0214 3.80843 28.1569 2.92387 30.3835 2.92383H35.3997C35.1532 3.52952 35.0593 4.1865 35.1264 4.83699C35.1934 5.48747 35.4192 6.11152 35.784 6.65424C36.1488 7.19696 36.6414 7.64172 37.2184 7.9494C37.7954 8.25708 38.4392 8.41825 39.0931 8.41874H62.6685C63.3225 8.41825 63.9663 8.25708 64.5433 7.9494C65.1203 7.64171 65.6129 7.19695 65.9776 6.65423C66.3424 6.11151 66.5683 5.48747 66.6353 4.83699C66.7023 4.18651 66.6084 3.52952 66.362 2.92383H71.7327C73.9594 2.92387 76.0949 3.80843 77.6694 5.38293C79.2439 6.95742 80.1284 9.09289 80.1285 11.3196Z"
        fill="white"
      />
      <Path
        d="M41.0899 91.8825H40.2202L40.5102 74.8965H40.7999L41.0899 91.8825Z"
        fill="#E6E6E6"
      />
      <Path
        d="M41.8147 64.2016L43.2184 62.0323C42.8021 60.8824 42.3213 59.7569 41.7783 58.6612L40.8706 59.3943L41.5893 58.2836C40.9044 56.9354 40.3655 56.0859 40.3655 56.0859C40.3655 56.0859 37.5503 60.5221 36.6098 65.219L38.4111 68.0027L36.417 66.3921C36.346 66.9393 36.3095 67.4903 36.3076 68.0421C36.3076 73.6047 38.1244 78.1142 40.3655 78.1142C42.6065 78.1142 44.4233 73.6047 44.4233 68.0421C44.4233 66.3176 44.0332 64.5134 43.495 62.8444L41.8147 64.2016Z"
        fill="#E6E6E6"
      />
      <Path
        d="M63.7285 91.8825H62.8589L63.1488 74.8965H63.4386L63.7285 91.8825Z"
        fill="#E6E6E6"
      />
      <Path
        d="M64.4529 64.2016L65.8566 62.0323C65.4403 60.8824 64.9595 59.7569 64.4165 58.6612L63.5088 59.3943L64.2275 58.2836C63.5426 56.9354 63.0036 56.0859 63.0036 56.0859C63.0036 56.0859 60.1885 60.5221 59.248 65.219L61.0492 68.0027L59.0552 66.3921C58.9842 66.9393 58.9476 67.4903 58.9458 68.0421C58.9458 73.6047 60.7625 78.1142 63.0036 78.1142C65.2447 78.1142 67.0615 73.6047 67.0615 68.0421C67.0615 66.3176 66.6713 64.5134 66.1332 62.8444L64.4529 64.2016Z"
        fill="#E6E6E6"
      />
      <Path
        d="M40.428 35.5758C44.8408 35.5758 48.4181 31.9985 48.4181 27.5858C48.4181 23.173 44.8408 19.5957 40.428 19.5957C36.0153 19.5957 32.438 23.173 32.438 27.5858C32.438 31.9985 36.0153 35.5758 40.428 35.5758Z"
        fill="#E6E6E6"
      />
      <Path
        d="M51.4951 89.4084H49.7021L50.2999 54.3848H50.8974L51.4951 89.4084Z"
        fill="#E6E6E6"
      />
      <Path
        d="M52.9893 32.3333L55.8835 27.8604C55.0252 25.4895 54.0339 23.1688 52.9142 20.9096L51.0427 22.4212L52.5246 20.131C51.1124 17.3511 50.0011 15.5996 50.0011 15.5996C50.0011 15.5996 44.1966 24.7465 42.2574 34.4311L45.9714 40.1709L41.8598 36.85C41.7134 37.9781 41.6381 39.1144 41.6343 40.252C41.6343 51.7217 45.3802 61.0197 50.0011 61.0197C54.622 61.0197 58.368 51.7217 58.368 40.252C58.368 36.6963 57.5636 32.9762 56.4539 29.535L52.9893 32.3333Z"
        fill="#E6E6E6"
      />
      <Path
        d="M81.3348 94.4558V118.265C81.3347 120.584 80.4135 122.808 78.7736 124.448C77.1338 126.088 74.9098 127.009 72.5907 127.009H29.5258C27.2068 127.009 24.9827 126.088 23.3429 124.448C21.703 122.808 20.7818 120.584 20.7817 118.265V96.7771C24.4748 92.4418 29.0271 88.9198 34.1508 86.4336C39.2745 83.9474 44.8582 82.5511 50.549 82.333C56.2399 82.1148 61.9141 83.0795 67.2131 85.1662C72.5121 87.2528 77.3206 90.416 81.3348 94.4558Z"
        fill="#004170"
      />
      <Path
        opacity="0.2"
        d="M51.1037 117.942C57.8606 117.942 63.3382 112.464 63.3382 105.707C63.3382 98.9502 57.8606 93.4727 51.1037 93.4727C44.3467 93.4727 38.8691 98.9502 38.8691 105.707C38.8691 112.464 44.3467 117.942 51.1037 117.942Z"
        fill="#E40046"
      />
      <Path
        d="M51.1036 115.56C56.5443 115.56 60.9548 111.149 60.9548 105.709C60.9548 100.268 56.5443 95.8574 51.1036 95.8574C45.663 95.8574 41.2524 100.268 41.2524 105.709C41.2524 111.149 45.663 115.56 51.1036 115.56Z"
        fill="#E40046"
      />
      <Path
        d="M48.9836 111.159L45.5117 106.696L47.5307 105.125L49.1744 107.239L54.7275 101.377L56.5845 103.136L48.9836 111.159Z"
        fill="white"
      />
    </Svg>
  );
}

export default Landing;
